export default __webpack_public_path__ + "static/media/hero_videoclipe.a8e35fc4.gif";